<script setup lang="ts">
import { computed, ref } from 'vue';
import ContactCard from '../../../ContactCard/ContactCard.vue';

type ContactCardProps = InstanceType<typeof ContactCard>['$props'];

export type Props = {
  contacts: ContactCardProps[];
  title?: string;
  selectedCountry?: string;
};

const props = defineProps<Props>();

const contactsData = ref<ContactCardProps[] | undefined>(props.contacts);

const contactForm = computed(() => {
  if (contactsData.value) {
    return {
      name: 'Kontaktformular',
      url: '/',
    };
  }
  return null;
});
</script>
<template>
  <div :class="$style.container">
    <h3 v-if="title && contactsData?.length">{{ title }} {{ selectedCountry }}</h3>
    <div v-if="!contactsData || !contactsData.length" :class="$style.noResults">
      <p>
        <strong>{{ 'Keine Treffer gefunden' }}</strong>
        {{
          'Bitte überprüfen Sie die Eingabe Ihrer Postleitzahl oder senden Sie uns eine Anfrage über das'
        }}
        <a v-if="contactForm?.url" :href="contactForm?.url">{{ contactForm?.name }}</a>
      </p>
    </div>
    <ContactCard
      v-for="(contact, index) in contactsData"
      :key="index"
      :additional-text="contact.additionalText"
      :address="contact.address"
      :city="contact.city"
      :company="contact.company"
      :country="contact.country"
      :description="contact.description"
      :email="contact.email"
      :fax="contact.fax"
      :media="contact.media"
      :mobile="contact.mobile"
      :name="contact.name"
      :position="contact.position"
      :street="contact.street"
      :tel="contact.tel"
      :type="contact.type"
      :v-card="contact.vCard"
      :website="contact.website"
      :website-text="contact.websiteText"
    />
  </div>
</template>
<style lang="sass" module src="./ContactResults.scss" />
